<template>
  <div v-if="noticeVisible" :style="`height:${pageHeight}px`">
    <div class="noticeBox">
      <div class="title">消息</div>
      <div class="content">
        <noticeItem v-for="item in noticeList" :key="item.notificationId" :item="item" />
        <empty description="暂无消息" v-if="noticeList.length === 0" />
      </div>
      <div class="bottom" v-show="unreadCount > 0" @click="putNotificationReadAll">全部已读</div>
    </div>
    <div class="mask" @click="setNoticeVisible(false)"></div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import noticeItem from "./noticeItem.vue";
export default {
  components: {
    noticeItem,
  },
  data() {
    return {
      visible: false,
      pageHeight: 0,
    };
  },
  created() {},
  computed: {
    ...mapState("notice", ["noticeVisible", "noticeList"]),
    ...mapGetters("notice", ["unreadCount"]),
  },
  methods: {
    ...mapActions("notice", ["setNoticeVisible","putNotificationReadAll"]),
  },
};
</script>

<style scoped lang="scss">
.noticeBox {
  position: absolute;
  right: 24px;
  top: 60px;
  width: 400px;
  height: 400px;
  border-radius: 10px;
  opacity: 1;

  /* 白色 */
  background: #ffffff;

  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  z-index: 10;
  display: flex;
  flex-direction: column;
  .title {
    display: flex;
    height: 50px;
    padding: 0 16px;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #262626;
    border-bottom: 1px solid #eeeeee;
  }
  .content {
    flex: 1;
    overflow-y: auto;
  }
  .bottom {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #999999;
    width: calc(100% - 32px);
    border-top: 1px solid #eeeeee;
    margin: 0 auto;
    cursor: pointer;
  }
}
.mask {
  background-color: rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9;
  touch-action: none;
}
</style>
